import { gql } from '@apollo/client'

export const LEGAL_FORMALITIES_MONITORING_QUERY = gql`
  query LegalFormalitiesMonitoring(
    $from: ISO8601Date!
    $to: ISO8601Date!
    $granularity: String
  ) {
    legalFormalitiesMonitoring(
      from: $from
      to: $to
      granularity: $granularity
    ) {
      globalKpis {
        totalCompleted
        totalClosed
        totalInProgress
        totalCreated
      }
      volumeOverTime {
        period
        count
      }
      byFormalityType {
        label
        count
      }
      byLegalForm {
        label
        count
      }
      performance {
        avgProcessingDays
        rejectionRate
        avgClientWaitDays
        avgEffectiveWorkDays
      }
    }
  }
`
